import useMutation from "src/hooks/useMutation";

function useOrderUpdate(id) {
  return useMutation({
    path: `/api/v1/orders/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: [`/api/v1/orders`, `/api/v1/orders/count`],
      shouldRevalidate: true,
    },
  });
}

export default useOrderUpdate;
